import * as React from "react"
import { UploadIcon, DownloadIcon } from "@iconsGallery"
import { ExportButton, PortButton } from "./styles"
import { ExcelExport } from "@progress/kendo-react-excel-export"
import _ from "lodash"
import {
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
  useMediaQuery,
} from "@material-ui/core"
import { CloseRounded } from "@material-ui/icons"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { useEffect } from "@storybook/addons"
import {
  instructionSheetNONAvalara,
  instructionSheetAvalara,
} from "./InstructionFixture"
const useStyles = makeStyles({
  card: {
    width: "48%",
    padding: "10px",
    boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.07)",
    "@media(max-width:700px)": {
      width: "100%",
      margin: "10px",
      display: "flex",
      flexDirection: "column",
    },
  },
  cardSingel: {
    width: "100%",
    padding: "10px",
    boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.07)",
    "@media(max-width:700px)": {
      width: "100%",
      margin: "10px",
      display: "flex",
      flexDirection: "column",
    },
  },
  radioGroupWrap: {
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
  },
  firstHead: {
    textAlign: "center",
    fontWeight: 500,
    fontSize: "17px",
  },
  secondHead: {
    textAlign: "center",
    padding: "10px",
  },
  clr10: {
    height: "10px",
    clear: "both",
  },
  imgWrap: {
    textAlign: "center",
    margin: "10px 0px 20px 0px",
  },
  radioBtn: {
    display: "flex",
    justifyContent: "flex-end",
    "& .MuiFormControlLabel-root": {
      marginRight: "0px",
    },
    "& .MuiButtonBase-root": {
      padding: "0px",
    },
  },
  DialogMainWrapper: {
    height: "100%",
    width: "750px",
    margin: "auto",
    "@media(max-width:700px)": {
      width: "100%",
      padding: "20px 5px",
      display: "flex",
      flexDirection: "column",
    },
  },
})

const ExportButtonUI = (props) => {
  const {
    file = "sampleExport.csv",
    label = "Export",
    exportGridData = [],
    columnData = [],
    handleExportFormat = () => {},
    onSaveCompleted = () => {},
    disabled = false,
    isOnlyAll = false,
    type = "1",
    isTimestamp = false,
  } = props || {}

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"))
  const classes = useStyles()
  const _export = React.useRef(null)
  const [isOpen, setIsOpen] = React.useState(false)
  const [extensionValue, setExtensionValue] = React.useState("xls")
  const [exportTypeVal, setExportTypeVal] = React.useState(
    isOnlyAll ? "allRecords" : ""
  )
  const [fileName, setFileName] = React.useState(`${file}`)
  const [exportFormatData, setExportFormatData] = React.useState([])
  const handleClick = () => {
    setIsOpen(true)
    setExportTypeVal(isOnlyAll ? "allRecords" : "")
    setExtensionValue("xls")
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const adopterFunction = (dataState, page, limit, additionalFilters = []) => {
    let sort = {}
    let isLookUp = false
    let searchTerm = ""
    let attSearchVal = ""
    if (isLookUp) {
      sort = dataState?.sort?.reduce((acc, o) => {
        acc[o.field] = o.dir
        return acc
      }, {})
      return {
        page,
        limit,
        filter: [
          ...(dataState?.filter?.filters || []),
          ...(additionalFilters || []),
        ],
        sort,
        searchTerm: attSearchVal,
      }
    } else if (searchTerm !== "") {
      sort = dataState?.sort?.reduce((acc, o) => {
        acc[o.field] = o.dir
        return acc
      }, {})
      return {
        page,
        limit,
        filter: [
          ...(dataState?.filter?.filters || []),
          ...(additionalFilters || []),
        ],
        sort,
        searchTerm: searchTerm,
      }
    } else {
      sort = dataState?.sort?.reduce((acc, o) => {
        acc[o.field] = o.dir === "asc" ? 1 : -1
        return acc
      }, {})
      return {
        page,
        limit,
        filter: [
          ...(dataState?.filter?.filters || []),
          ...(additionalFilters || []),
        ],
        sort,
      }
    }
  }
  const excelExport = async (type) => {
    let sort = exportGridData?.sort?.reduce((acc, o) => {
      acc[o.field] = o.dir === "asc" ? 1 : -1
      return acc
    }, {})

    let bodyData = {}
    let bodyKit = {}
    if (type === "currentView") {
      // bodyData = {
      //   filter: exportGridData?.filter?.filters,
      //   limit: exportGridData.totalDocs,
      //   page: 1,
      //   sort,
      // }
      bodyKit = adopterFunction(
        exportGridData,
        Math.floor(exportGridData.skip / exportGridData.take) + 1,
        exportGridData.take,
        []
      )
      // bodyData = {
      //   filter: exportGridData?.filter?.filters,
      //   sort,
      //   limit: exportGridData?.limit || 1,
      //   page: exportGridData.page,
      // }
    }

    let exportFormatData = await handleExportFormat(bodyKit, type)
    setExportFormatData(exportFormatData)
    if (_export.current !== null) {
      if (file.includes("Product-Export")) {
        let visibleColumns = _.filter(columnData, _.matches({ show: true }))

        let taxFiled = visibleColumns.filter((itm) => itm.field === "taxCode")

        if (!_export.current) return

        if (!exportFormatData?.length) {
          console.warn("❌ No export data found")
          return
        }

        if (!visibleColumns?.length) {
          console.warn("❌ No visible columns found")
          return
        }

        // ✅ CREATE EMPTY WORKBOOK
        const exportOptions = _export.current.workbookOptions()

        // ✅ -------------------------------
        // ✅ SHEET 1 → INSTRUCTION SHEET
        // ✅ -------------------------------
        const instructionSheet =
          taxFiled.length > 0
            ? instructionSheetAvalara
            : instructionSheetNONAvalara

        const productHeaderRow = {
          height: 56,
          cells: visibleColumns.map((col) => ({
            value: col.title || col.field,
            bold: false,
            background: col?.backgroundColor || "#1E3A8A",
            color: "#000000",
            textAlign: "center",
            verticalAlign: "center",
            wrap: true,
          })),
        }

        const dataRows = exportFormatData.map((item) => ({
          cells: visibleColumns.map((col) => {
            const { isDropdown = false, dropdownValue = [] } = col || {}

            let obj = {}
            if (isDropdown) {
              obj = {
                dataValidation: {
                  dataType: "list",
                  from: `"${dropdownValue.join(",")}"`,
                  allowNulls: true,
                  showButton: true,
                  showInputMessage: true,
                  inputTitle: "Select",
                  inputMessage: "Choose a value from the list",
                },
              }
            }
            return {
              value: item[col.field] ?? "",
              ...obj,
            }
          }),
        }))

        const productSheet = {
          name: "Products",
          rows: [productHeaderRow, ...dataRows],
          columns: visibleColumns.map(() => ({
            autoWidth: true,
          })),
        }

        exportOptions.sheets = [instructionSheet, productSheet]

        //SAVE FILE
        _export.current.save(exportOptions)
      } else {
        _export.current.save(
          exportFormatData,
          _.filter(columnData, _.matches({ show: true }))
        )
      }
    }
    await handleClose()
  }

  const handleExport = () => {
    const now = new Date()
    const months = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
     ];
    const day = String(now.getDate()).padStart(2,'0')
    const month = months[now.getMonth()]
    const year = now.getFullYear()
    let hours = now.getHours()
    let minutes = String(now.getMinutes()).padStart(2,'0')
    let AMPM=now.getHours()>=12?"PM":"AM"
    const formatted = `${day}-${month}-${year} ${hours}_${minutes}${AMPM}`
    let lcGetFileName = isTimestamp
      ? file + "_" + formatted
      : file + "." + extensionValue
    setFileName(lcGetFileName)

    if (isOnlyAll) {
      excelExport("allRecords")
    } else {
      if (exportTypeVal === "allRecords") {
        excelExport("allRecords")
      } else if (exportTypeVal === "currentView") {
        excelExport("currentView")
      }
    }
  }

  const portAttr = {
    startIcon: <DownloadIcon style={{ width: "16px", paddingLeft: "2px" }} />,
    variant: "outlined",
    onClick: type === "1" ? () => handleClick() : () => handleExport(),
    style: {
      width: "100%",
      padding: "5px 10px",
      marginBottom: "0px",
      maxWidth: "unset",
      cursor: "pointer",
    },
    disabled: disabled,
  }

  return (
    <>
      <ExcelExport
        data={exportFormatData}
        fileName={fileName}
        ref={_export}
        sheetName="Products"
        onExportComplete={onSaveCompleted}
      />
      {type === "1" ? (
        <PortButton {...portAttr}>{label}</PortButton>
      ) : (
        <div
          {...portAttr}
          style={{
            width: "100%",
            padding: "5px 10px",
            marginBottom: "0px",
            maxWidth: "unset",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            textDecoration: "underline",
            fontSize:"12px"
          }}
        >
          <DownloadIcon style={{ width: "16px", paddingLeft: "2px" }} />
          <span className="cls-portbutton-export-label">{label}</span>
        </div>
      )}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        maxWidth={"lg"}
        className={classes.DialogMainWrapper}
      >
        <DialogTitle
          id="customized-dialog-title"
          style={{ padding: "10px 20px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Export
            <IconButton size="small" onClick={() => handleClose()}>
              <CloseRounded />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers style={{ padding: "20px 32px" }}>
          <Typography style={{ fontWeight: "500", fontSize: "16px" }}>
            Which data do you want to export?
          </Typography>
          <Typography
            style={{
              fontWeight: "400",
              fontSize: "14px",
              marginTop: "16px",
              lineHeight: "20px",
            }}
          >
            Export your data in the format that suits your needs. If you have a
            lot of data, the number of rows you export might be limited
            depending on the file type you select.
          </Typography>
          <RadioGroup
            aria-label="quiz"
            name="quiz"
            value={exportTypeVal}
            onChange={(e) => setExportTypeVal(e.target.value)}
            className={classes.radioGroupWrap}
          >
            {!isOnlyAll && (
              <Card className={classes.card} style={{ marginRight: "12px" }}>
                <div className={classes.radioBtn}>
                  <FormControlLabel value="currentView" control={<Radio />} />
                </div>
                <div className={classes.imgWrap}>
                  <img src="/static/img/currentView.svg" alt="Current View" />
                </div>
                <div>
                  <Typography className={classes.firstHead}>
                    {`Current View`}
                  </Typography>
                  <Typography className={classes.secondHead}>
                    Export this data in the same layout you see now.
                  </Typography>
                </div>
                <div className={classes.clr10}></div>
              </Card>
            )}
            <Card
              className={isOnlyAll ? classes.cardSingel : classes.card}
              style={{ marginLeft: "12px" }}
            >
              <div className={classes.radioBtn}>
                <FormControlLabel
                  className={classes.radioBtn}
                  value="allRecords"
                  control={<Radio />}
                />
              </div>
              <div className={classes.imgWrap}>
                <img src="/static/img/allRecords.svg" alt="All Records" />
              </div>
              <div>
                <Typography className={classes.firstHead}>
                  All Records
                </Typography>
                <Typography className={classes.secondHead}>
                  Export the summarized data used to create your product.
                </Typography>
              </div>
            </Card>
          </RadioGroup>
          <div style={{ marginTop: "20px" }}>
            <Typography style={{ marginBottom: "5px" }}>
              File format:
            </Typography>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={extensionValue}
              onChange={(e) => setExtensionValue(e.target.value)}
              variant="outlined"
              style={{ width: "100%", height: "45px" }}
              placeholder="Select"
            >
              <MenuItem value="xls">Excel (.xls)</MenuItem>
              <MenuItem value="xlsx">Excel Open XML (.xlsx)</MenuItem>
              <MenuItem value="csv">Comma Separated Values (.csv)</MenuItem>
            </Select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "30px 0px 0px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setExtensionValue("xls")
                setExportTypeVal("")
              }}
            >
              RESET
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleExport()}
              style={{
                backgroundColor:
                  exportTypeVal === "" || extensionValue === ""
                    ? "gray"
                    : "var(--primaryColor)",
                color: "#fff",
              }}
              disabled={exportTypeVal === "" || extensionValue === ""}
            >
              EXPORT
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

export { ExportButtonUI }
export default ExportButtonUI
